export const GET_ENGENEERS = 'app/get_engineers'
export const DELETE_ENGINEER_BY_ID = 'app/delete_engineer'
export const CREATE_ENGENEER = 'app/create_engineer'
export const GET_ENGINEER_BY_ID = 'app/get_engineer_by_id'
export const UPDATE_ENGINEER = 'app/update_engineer'
